import React from "react";
import {
  UpdateCategoryMutationVariables,
  useCategoryQuery,
  useUpdateCategoryMutation,
} from "../../generated/graphql";
import { useToast } from "@chakra-ui/react";
import Loading from "../../components/loading/Loading";
import { Navigate, useNavigate } from "react-router-dom";
import Form from "./Form";

interface Props {
  id: string;
}

const Update: React.VFC<Props> = ({ id }) => {
  const [updateCategory] = useUpdateCategoryMutation();
  const navigation = useNavigate();
  const toast = useToast();

  const { loading, error, data } = useCategoryQuery({
    variables: {
      where: {
        id,
      },
    },
    fetchPolicy: "network-only",
  });

  if (loading) {
    return <Loading />;
  }
  if (error) {
    return <Navigate to={"/category"} replace />;
  }

  const handleUpdateCategory = async (data: UpdateCategoryMutationVariables) => {
    try {
      await updateCategory({
        variables: {
          ...data,
        },
      });

      return toast({
        status: "success",
        title: "Success",
        description: "Category updated",
        duration: 1000,
        onCloseComplete: () => {
          return navigation("/category");
        },
      });
    } catch (error: any) {
      console.log(error.message);
      return toast({
        status: "error",
        title: "Error",
        description: "An error occured",
        duration: 1000,
      });
    }
  };

  return (
    <Form
      actionType="UPDATE"
      data={data?.category}
      id={id}
      handleUpdateCategory={handleUpdateCategory}
    />
  );
};

export default Update;
